import { t } from 'shared/locale/texts';

import type { FlightSearchState } from '../../../flight/flightDefaultState';

export const useFlightValidation = (form: Partial<FlightSearchState>, pristine: boolean) => {
    const invalid = {
        origin: !pristine && !form.origin,
        destination: !pristine && !form.destination,
        sameOriginDestination: !pristine && form.origin === form.destination,
        origin2: !pristine && !form.origin2,
        destination2: !pristine && !form.destination2,
        sameOriginDestination2: !pristine && form.origin2 === form.destination2,
        departureDate: !pristine && !form.departureDate,
        returnDate: !pristine && form.tripType !== 'oneway' && !form.returnDate,
        returnDateAfterDeparture: !pristine && form.returnDate && form.departureDate && form.returnDate < form.departureDate,
    };

    const validationErrors = {
        origin: invalid.origin ? t('flight.validation.origin') : null,
        destination: invalid.destination ? t('flight.validation.destination') : null,
        sameOriginDestination: invalid.sameOriginDestination ? t('flight.validation.sameOriginDestination') : null,
        origin2: invalid.origin2 ? t('flight.validation.origin') : null,
        destination2: invalid.destination2 ? t('flight.validation.destination') : null,
        sameOriginDestination2: invalid.sameOriginDestination2 ? t('flight.validation.sameOriginDestination') : null,
        departureDate: invalid.departureDate ? t('flight.validation.departureDate') : null,
        returnDate: invalid.returnDate ? t('flight.validation.returnDate') : null,
        returnDateAfterDeparture: invalid.returnDateAfterDeparture ? 'Hjemreise dato må være etter utreise dato' : null,
    };

    return { invalid, validationErrors };
};
